<mat-drawer-container>
  <mat-drawer class="settings-drawer" mode="over" position="end" 
  [opened]="settingsDrawer.state()" (closedStart)="settingsDrawer.state.set(false)">
    <div class="drawer-header">{{ settingsDrawer.heading }}</div>
    <lib-user-settings></lib-user-settings>
  </mat-drawer>
  <mat-drawer-content>
<qbuilt-navbar class="nav-bar-styling" [isHomePage]="true"></qbuilt-navbar>
@if (isLoading) {
    <div class="page-container">
        <div class="loading-spinner">
            <mat-spinner diameter="300" class="secret"></mat-spinner>
        </div>
    </div>
} @else {
  <div class="page-container">
    <div class="top-page-content">
        <div class="tech-name-section">
            <div class="title">{{ techNameTitle }}</div>
            @if(managerWalkSelected) {
                <dropdown-component [dropdownType]="'managerWalkUser'" [managerWalkUsers]="managerWalkUsers" 
                (managerWalkUserSelected)="onManagerWalkUserSelected($event)"></dropdown-component>
            } @else {
                <div>{{this.fullName}}</div>
            }
        </div>
        <div class="tech-name-section">
                <div class="title">{{ facilityTitle }}</div>
                <div>{{this.facilityNumber}}</div>
        </div>
        <dropdown-component style="padding-top: 25px;" [dropdownType]="'zone'" [zones]="userZoneList" (zoneSelected)="onZoneSelected($event)"></dropdown-component>
    </div>
    <hr class="line-break" />
    <div class="bottom-page-content">
      @if (inspectionSetup) {
        <div class="search-title">{{ searchTitle }}</div>
        <serial-search
          (serialCheck)="onSerialCheck($event)"
          [serialNumberList]="serialSectionList"
        ></serial-search>
        <div class="start-btn">
          <large-button
            [buttonText]="startBtnText"
            [buttonDisabled]="btnDisabled"
            (click)="startInspection(serialNumber)"
          ></large-button>
        </div>
    }
    @if(showSetupBtn && !inspectionSetup) {
        @if(!managerWalkUserSelected) {
            <large-button [buttonText]="btnText" [buttonDisabled]="tabLoading" (click)="inspectionSetupTrigger()"></large-button>
        } @else {
            <large-button [buttonText]="btnText" [buttonDisabled]="tabLoading || !managerWalkUserSelected" (click)="inspectionSetupTrigger()"></large-button>
        }
    }
    @if(tabLoading){
        <div>
          <button class="ai-button" [disabled]="true" (click)="(false)">
            <mat-spinner diameter="80"></mat-spinner>
            <div class="ai-text">{{ activeInspectionsTitle }}</div>
          </button>
        </div>
    } @else {
        @if(!managerWalkSelected) {
            <div>
                <button class="ai-button" [disabled]="!activeInspections" (click)="goToActiveInspections(zoneName)">
                    <span class="material-symbols-outlined ai-icon">description</span>
                    <div class="ai-text">{{activeInspectionsTitle}}</div>
                </button>
            </div>
        } @else {
            <div>
                <button class="ai-button" [disabled]="!activeInspections || !managerWalkUserSelected" (click)="goToActiveInspections(zoneName)">
                    <span class="material-symbols-outlined ai-icon">description</span>
                    <div class="ai-text">{{activeInspectionsTitle}}</div>
                </button>
            </div>
        }
    }
    </div>
        <div class="logout-section">
        <button class="logout-button" (click)="userLogout()">
            <span class="material-symbols-outlined logout-icon">logout</span>
            <div>{{logoutText}}</div>
        </button>
        </div>
    </div>
}
  </mat-drawer-content>
</mat-drawer-container>
